import { render } from "./AuthForm.vue?vue&type=template&id=65118726&scoped=true"
import script from "./AuthForm.vue?vue&type=script&lang=js"
export * from "./AuthForm.vue?vue&type=script&lang=js"

import "./AuthForm.vue?vue&type=style&index=0&id=65118726&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65118726"]])

export default __exports__